import ErrorsContainer from './Errors.container';

export default ErrorsContainer;



// WEBPACK FOOTER //
// ./src/app/modules/Errors/index.js